<template>
  <a></a>
</template>

<script>
export default {
  name: "EventPage"
}
</script>

<style scoped>

</style>